import React from 'react';
import LoginWindow from '../components/Auth/LoginWIndow';

const LoginPage = () => {
  return (
    <div className="flex-1">
      <LoginWindow />
    </div>
  )
}

export default LoginPage;